import React from "react";
import "../styles/ViewOnce.css";

function ViewOnceToggle({ enabled, onChange, disabled = false }) {
  return (
    <button
      type="button"
      className={`view-once-toggle${enabled ? " active" : ""}`}
      onClick={() => !disabled && onChange(!enabled)}
      disabled={disabled}
      title="Receiver can open this media only once"
    >
      <span className="view-once-badge" aria-hidden="true">
        ①
      </span>
      View once
    </button>
  );
}

export default ViewOnceToggle;
